import React from 'react';
import { motion } from 'framer-motion';
import { Phone, ShieldCheck, Clock, BadgeDollarSign, Users } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-brand-navy" data-id="element-118">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-119">
        <img src="https://images.unsplash.com/photo-1585704032915-c3400ca199e7?q=80&w=2070&auto=format&fit=crop" alt="Industrial copper plumbing pipes" className="w-full h-full object-cover object-center opacity-50" data-id="element-120" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/90 to-brand-navy/40" data-id="element-121"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-122">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-123">
          {/* Text Content */}
          <div className="lg:col-span-7" data-id="element-124">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-125">
              <span className="inline-block py-1 px-3 rounded bg-brand-red/20 border border-brand-red/30 text-brand-red font-bold tracking-wider uppercase text-sm mb-6 backdrop-blur-sm" data-id="element-126">
                Residential • Commercial • Service
              </span>
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-display font-bold text-white leading-tight mb-6 uppercase" data-id="element-127">
                34 Years. <br data-id="element-128" />
                <span className="text-brand-red" data-id="element-129">Done Right.</span>
              </h1>
              <p className="text-lg sm:text-xl text-gray-300 mb-10 max-w-2xl leading-relaxed" data-id="element-130">
                Trusted plumbing solutions for homes and businesses since 1990.
                When you need it fixed fast and fixed right the first time,
                we're the team to call.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-131">
                <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-white bg-brand-red hover:bg-brand-redDark rounded-md transition-colors uppercase tracking-wide" data-id="element-132">
                  Get a Free Quote
                </a>
                <a href="tel:7026425352" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-white border-2 border-white/30 hover:border-white hover:bg-white/10 rounded-md transition-all uppercase tracking-wide gap-2" data-id="element-133">
                  <Phone className="w-5 h-5" data-id="element-134" />
                  Call (702) 642-5352
                </a>
              </div>
            </motion.div>

            {/* Trust Row */}
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-8 border-t border-white/10" data-id="element-135">
              {[{
              icon: ShieldCheck,
              text: 'Licensed & Insured'
            }, {
              icon: Users,
              text: 'Family-Owned Since 1990'
            }, {
              icon: Clock,
              text: '24/7 Emergency'
            }, {
              icon: BadgeDollarSign,
              text: 'Upfront Pricing'
            }].map((item, i) => <div key={i} className="flex items-center gap-2 text-gray-300" data-id="element-136">
                  <item.icon className="w-5 h-5 text-brand-red shrink-0" data-id="element-137" />
                  <span className="text-sm font-medium" data-id="element-138">{item.text}</span>
                </div>)}
            </motion.div>
          </div>

          {/* Inset Image (Desktop Only) */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="hidden lg:block lg:col-span-5 relative" data-id="element-139">
            <div className="relative rounded-md overflow-hidden shadow-2xl border-4 border-white/10" data-id="element-140">
              <div className="absolute inset-0 bg-brand-navy/15 mix-blend-multiply z-10" data-id="element-141"></div>
              <img src="https://images.unsplash.com/photo-1542013936693-884638332954?q=80&w=1000&auto=format&fit=crop" alt="Plumber repairing pipes under a sink" className="w-full h-[500px] object-cover" data-id="element-142" />
            </div>
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-brand-red rounded-md -z-10" data-id="element-143"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 border-2 border-brand-red/30 rounded-md -z-10" data-id="element-144"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}